'use strict';

module.exports = require('../5/CheckObjectCoercible');



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/2020/RequireObjectCoercible.js
 ** module id = 1282
 ** module chunks = 0
 **/